import './HeaderMedia.css';
import React from 'react';
import { get, canUseDOM, pathJoin, getDomain } from '../../utils';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { tealiumClickFunc } from '../../utils/tealium';
import { addDefaultValues } from '../../utils/analytics';
var HeaderMedia = function HeaderMedia(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    carouselEvent = _ref.carouselEvent,
    mediaDesc = _ref.mediaDesc,
    rendering = _ref.rendering;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  var imageSrc = get(fields, 'data.item.image.jss.value.src', '');
  var imageAlt = get(fields, 'data.item.image.jss.value.alt', '');
  var videoSrc = get(fields, 'data.item.video.jss.value.href', '');
  var videoName = get(fields, 'data.item.name', '');
  var videoType = get(fields, 'data.item.video.jss.value.linktype', '');
  var videoAnalytics = get(fields, 'data.videoAnalytics');
  var imageRef = React.useRef();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var animated = params !== undefined && params.animation === 'true' ? true : false;
  console.log(params, 'params  ');
  console.log(addDefaultValues(params));
  var publicationDate = get(fields, 'data.item.publicationDate.jss.value', '');
  var videoDescription = get(fields, 'data.item.description');
  var script = videoType !== 'external' ? "{\n      \"@context\": \"https://schema.org\",\n      \"@type\": \"VideoObject\",\n      \"name\": \"".concat(videoName, "\",\n      \"description\": \"").concat(videoDescription ? videoDescription : mediaDesc, "\",\n      \"thumbnailUrl\": [\"").concat(pathJoin([getDomain(), imageSrc]), "\"],\n      \"uploadDate\": \"").concat(publicationDate, "\",\n      \"contentUrl\": \"").concat(pathJoin([getDomain(), videoSrc]), "\"\n    }") : "{\n      \"@context\": \"https://schema.org\",\n      \"@type\": \"VideoObject\",\n      \"name\": \"".concat(videoName, "\",\n      \"description\": \"").concat(videoDescription ? videoDescription : mediaDesc, "\",\n      \"thumbnailUrl\": [\"").concat(pathJoin([getDomain(), imageSrc]), "\"],\n      \"uploadDate\": \"").concat(publicationDate, "\",\n      \"embedUrl\": \"").concat(videoSrc, "\"\n    }");
  if (!fields || !imageSrc) {
    console.info('HeaderMedia component render skipped. No fields provided');
    return pageEditing ? /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, "[Header Media: please provide data source or item should have headerImage field]") : null;
  }
  var imgLoadedEvent = function imgLoadedEvent() {
    if (canUseDOM) {
      var isHeaderGeneric = imageRef.current.closest('.header-generic--primary');
      if (isHeaderGeneric) {
        var animButton = isHeaderGeneric.getElementsByClassName('header-animation-trigger');
        if (animButton && animButton.length) animButton[0].click();
      }
    }
  };
  var renderImage = function renderImage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, canUseDOM && /*#__PURE__*/React.createElement("picture", {
      className: "styled-curved-image"
    }, document.getElementsByClassName('header-events').length === 1 ? /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 480px)",
      "data-header": "event",
      srcSet: "".concat(imageSrc, "&cw=795&ch=595")
      // srcSet="https://dotqa.testvisitdubai.com/-/media/dotsite/images/0-0-homepage/dtcmdubaitourismcityscapepurple.jpg?rev=a589d55c7fb54c64b1ed38d4bfe673e8&cx=0.22&cy=0.44&cw=1556&ch=690"
    }) : /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 480px)",
      "data-header": "normal",
      srcSet: "".concat(imageSrc, "&cw=1556&ch=690")
      // srcSet='https://dotqa.testvisitdubai.com/-/media/dotsite/images/0-0-homepage/dtcmdubaitourismcityscapepurple.jpg?rev=a589d55c7fb54c64b1ed38d4bfe673e8&cx=0.22&cy=0.44&cw=1556&ch=690'
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(imageSrc, "&cw=397&ch=397")
      // src="https://dotqa.testvisitdubai.com/-/media/dotsite/images/0-0-homepage/dtcmdubaitourismcityscapepurple.jpg?rev=a589d55c7fb54c64b1ed38d4bfe673e8&cx=0.22&cy=0.44&cw=1556&ch=690"
      ,

      ref: imageRef,
      onLoad: imgLoadedEvent,
      alt: imageAlt,
      "aria-hidden": "true",
      "aria-label": imageAlt
    })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
      videoSrc: videoSrc,
      videoType: videoType,
      loop: true,
      buttonTopAlignment: true,
      click: function click(param) {
        tealiumClickFunc(params, "".concat(param, ": ").concat(videoName));
      },
      carouselEvent: carouselEvent,
      structuredScriptData: script,
      structuredScript: true
    }), pageEditing && /*#__PURE__*/React.createElement(Image, {
      editable: true,
      field: get(fields, 'data.item.image.jss')
    }));
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, imageSrc && renderImage());
};
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "header-media ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle)
  }, children);
};
var commonStyles = "c1vj5c55";
var ltrStyles = "ll439xg";
var rtlStyles = "r1on2m9h";
export default HeaderMedia;